<template>
  <div class="search_input">
    <x-input
      v-model="currentValue"
      :placeholder="placeholder"
      :min="min"
      :max="max"
      :show-clear="showClear"
      :title="title"
      @on-change="handleChange"
      @on-focus="handleFocus"
      @on-blur="handleBlur"
      @on-click-clear-icon="handleClickClear"
    >
      <slot slot="label" name="label">
      </slot>
      <img src="../../assets/icon-search.png" slot='right' class="search_icon" @click.stop="handleSearch"/>
    </x-input>
  </div>
</template>
<script>
  import XInput from '../x-input/index'
  export default {
    components: { XInput },
    props: {
      placeholder: {
        type: String,
        default: '搜索'
      },
      value: {
        type: String,
        default: ''
      },
      min: Number,
      max: Number,
      showClear: {
        type: Boolean,
        default: true
      },
      title: {
        type: String,
        default: ''
      },
      type: {
        type: String,
        default: 'text'
      }
    },
    data() {
      return {
        currentValue: this.value
      }
    },
    methods: {
      handleBlur() {
        this.$emit('on-blur')
      },
      handleChange() {
        this.$emit('on-change', this.currentValue)
      },
      handleFocus() {
        this.$emit('on-focus')
      },
      handleSearch() {
        this.$emit('on-search')
      },
      handleClickClear() {
        this.$emit('on-click-clear-icon')
      }
    },
    watch: {
      value(val) {
        this.currentValue = val
      },
      currentValue(newVal, oldVal) {
        this.$emit('input', newVal)
      }
    }
  }
</script>
<style lang="less">
  @import '../../styles/weui/base/fn';
  @import '../../styles/cui/widget/cui_cell/cui_cell_global';
  .search_input {
    background-color: #eee;
    padding: 20/@w2 30/@w2;
    font-size: 15px;
    border-radius: 4/@w2;
    .weui_cell{background-color: #fff;}
    .weui_input{line-height: 50/@w2}
    .weui_cell{
      padding: 15/@w2 30/@w2;
    }
    .search_icon {
      width: 40/@w2;
      margin-bottom: -10/@w2;
      margin-left: 10/@w2;
    }
  }
</style>




// WEBPACK FOOTER //
// search.vue?660b0fe4